import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Account } from '../../shared/sdk/models/Account';
import { AccessToken } from '../../shared/sdk/models/BaseModels';
import { AccountApi } from '../../shared/sdk/services/custom/Account';
import { Router } from '@angular/router';
import { PushNotificationsService, NotificationsService } from 'angular2-notifications';
import { PlatformApp } from '../../shared/services/app.service';
import { Http } from '@angular/http';
import { API_VERSION, BASE_URL } from '../../../environments/environment';
import { AccessGroupService } from '../../shared/services/accessgroup.service';
import { LoopBackAuth } from '../../shared/sdk/services/core/auth.service';

declare var window: any;

/*
 * We're loading this component asynchronously
 * We are using some magic with es6-promise-loader that will wrap the module with a Promise
 * see https://github.com/gdi2290/es6-promise-loader for more info
 */


@Component({
  selector: 'login',
  styleUrls: ['./login.component.scss'],
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit, OnDestroy {

  localState: any;
  // Create model instances and set the right type effortless
  account: Account = new Account();
  subscriptions: any = [];
  notifyOptions = PlatformApp.getNotificationOptions();
  errormessage: string = '';
  isPasswordExpire: boolean = false;
  userInfo: any;

  backgroundimage = "https://res.cloudinary.com/ampcome/image/upload/c_scale,w_1980/v1491285334/pexels-photo-57825_jvxezl.jpg";

  // Configure LoopBack Once or Individually by Component
  constructor(public route: ActivatedRoute, public accountApi: AccountApi, public _LoopBackAuth: LoopBackAuth,
    public _NotificationsService: NotificationsService, public _PushNotificationsService: PushNotificationsService,
    public router: Router, public http: Http, public accessGroupService: AccessGroupService) {
    if (this.accountApi.isAuthenticated()) {
      this.router.navigate(['/']); //Dashboard is hardcoded here , need to check what is the default page and set it here
    }
  }

  ngOnInit() {
    this.errormessage = '';
    this.subscriptions.push(this.route.data
      .subscribe((data: any) => {
        // your resolved data from route
        this.localState = data.yourData;
    }));
  }

  ngOnDestroy() {
    for (var i = 0; i < this.subscriptions.length; i++) this.subscriptions[i].unsubscribe();
  }

  focusFunction(): void {
    this.errormessage = '';
  }

  // Start making API calls right away
  signup(): void {
    this.subscriptions.push(this.accountApi.create(this.account)
      .subscribe((account: Account) => (this.account = account) && this.login()));
  }

  // Built-in LoopBack Authentication and Typings like Account and TokenInterface
  login(): void {
    this.subscriptions.push(this.accountApi.login(this.account).subscribe((token: AccessToken) => {
      this.accessGroupService._getAccessGroupInfoForUser(token.user);
      // console.log(token.user)
      if(token.user && token.user.id) {
        if(token.user && token.user.passwordExpireAt && this.isPasswordExpired(token.user.passwordExpireAt)) {
          this.isPasswordExpire = true;
          this._NotificationsService.info('Message', 'Password has expired. Please change the password and login again.');
          this.accountApi.logout();
          this.getEncryptedUser(token.user);
        } else {
          this.isPasswordExpire = false;
          this.redirect();
          // if(token.user && token.user.role && token.user.role != 'administrator') {
          //   this.accessGroupService.getAccessGroupInfoForUser(token.user)
          //   .map(res => res.json())
          //   .subscribe(accessgroup => {
          //     if(accessgroup && accessgroup.length > 0) {
          //       this.redirect();
          //     } else {
          //       this._NotificationsService.info('Message', 'Your not part of any access group.');
          //       this.accountApi.logout();
          //       this.redirect();
          //     }
          //   }, error => {
          //     this._NotificationsService.info('Message', 'Your not part of any access group.');
          //     console.log('Error while getting access group', error);
          //     this.accountApi.logout();
          //     this.redirect();
          //   });
          // } else if(token.user && token.user.role && token.user.role == 'administrator') {
          //   console.log('Current user in login>>', this._LoopBackAuth.getCurrentUserData());
          //   this.redirect();
          // }
        }
      } else { console.log('User not found.'); }
    }, err => {
      console.log('Error while login.', err);
      this.errormessage = err.message
    }));
  }

  public getEncryptedUser(user) {
    this.http.post(BASE_URL + '/' + API_VERSION +'/constructencrypteddata', {userid: user.id})
    .map(res => res.json())
    .subscribe(data => {
      console.log('Encrypted user.', data);
      this.userInfo = data.encrypteduser;
    }, error => {
      console.log('Error while constructing encrypted user.', error);
    });
  }

  public isPasswordExpired(passwordexpiredate): boolean {
    return new Date() >= new Date(passwordexpiredate);
  } 


  redirect(): void {
    this.router.navigate(['/']); //use the stored url here
  }

  goToPasswordResetPage(): void {
    this.router.navigate(['/passwordreset', { isPasswordExpired: this.isPasswordExpire, userinfo: this.userInfo}]).then(data => {
      console.log(data);
    }).catch(error => {
      console.log(error);
    })
  }

  notify(type, title?, content?, options?) {
    if (!options) options = PlatformApp.getNotificationOptions();
    if (!options.id) options.id = type + '-' + title + '_' + content;
    switch (type) {
      case 'success': this._NotificationsService.success(title, content, options); break;
      case 'alert': this._NotificationsService.alert(title, content, options); break;
      case 'error': this._NotificationsService.error(title, content, options); break;
      case 'info': this._NotificationsService.info(title, content, options); break;
      case 'bare': this._NotificationsService.bare(title, content, options); break;
      default: this._NotificationsService.info(title, content, options);
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/app-modules/login/login.component.ts